import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AcademicLevelService from "../../service/academicLevelService";
import "./AcademicLevelsSection.css";

const AcademicLevelsSection = () => {
  const [levels, setLevels] = useState([]);
  const [status, setStatus] = useState("loading");
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setStatus("loading");
    AcademicLevelService.getAcademicLevels({ signal: controller.signal }).then(result => {
      if (controller.signal.aborted) return;
      if (result.success && Array.isArray(result.data)) {
        setLevels(result.data.slice(0, 9));
        setStatus("ready");
      } else setStatus("error");
    });
    return () => controller.abort();
  }, [attempt]);

  return (
    <section className="home-levels-band" aria-labelledby="home-levels-title">
      <div className="container">
        <div className="home-levels-heading">
          <div>
            <span className="home-levels-eyebrow">À CHAQUE NIVEAU, SON PARCOURS</span>
            <h2 id="home-levels-title">Trouvez votre niveau</h2>
          </div>
          <Link to="/course-1">Tous les cours <i className="fa-solid fa-arrow-right" aria-hidden="true" /></Link>
        </div>
        {status === "loading" ? <p role="status">Chargement des niveaux…</p>
          : status === "error" ? <div><p role="alert">Impossible de charger les niveaux.</p><button type="button" className="ed-btn-theme" onClick={() => setAttempt(value => value + 1)}>Réessayer</button></div>
          : !levels.length ? <p>Aucun niveau disponible pour le moment.</p>
          : <div className="home-levels-grid">
            {levels.map(level => <Link className="home-level-card" key={level.id} to={`/course-1?levelId=${encodeURIComponent(level.id)}`}>
              <span className="home-level-icon"><i className="fa-solid fa-book-open" aria-hidden="true" /></span>
              <span className="home-level-label"><small>{level.academic_stage?.name || "Niveau scolaire"}</small><strong>{level.name}</strong></span>
              <i className="fa-solid fa-arrow-right home-level-arrow" aria-hidden="true" />
            </Link>)}
          </div>}
      </div>
    </section>
  );
};

export default AcademicLevelsSection;
